import { Menu } from "antd";
import React, { Component } from "react";
import { changeLeftMenuKpi, changeLeftMenuSubItem } from "../../actions/stats";
import { connect } from "react-redux";
import StatsUtils from "../../../../utils/stats";
import { kpis } from "../../../../configs/kpis";

const { SubMenu } = Menu;

class LeftMenuItem extends Component {
  constructor(props) {
    super(props);
  }

  onKpiSelected(e) {
    return;
  }

  onKpiViewSelected(event, view) {
    if (!this.props.graphLoading) {
      this.props.changeLeftMenuKpi(this.props.item.kpi.id, false, view);
    } else {
      //alert("stats loading please wait");
      //event.domEvent.preventDefault();
    }
    //this.props.changeLeftMenuSubItem(view);
  }

  isDashboardAvailable(kpi) {return false
    kpi.client_id = kpi.client_id || [];
    return (
      kpi.id !== 29 &&
      kpi.id !== 10 &&
      kpi.id !== 26 &&
      kpi.id !== kpis.LINEAR_CATEGORY &&
      kpi.id !== kpis.LINEAR_BRAND &&
      kpi.id !== kpis.PDL_BRAND &&
      kpi.id !== kpis.PDL &&
      kpi.id !== kpis.MEA &&
      kpi.id !== kpis.PLV &&
      kpi.id !== kpis.NB_BRI &&
      kpi.id !== kpis.NB_VENDEURS &&
      kpi.id !== kpis.PDL_FAMILY
    );
  }

  isPerfAvailable(kpi) {return false
    kpi.client_id = kpi.client_id || [];
    return (
      kpi.id !== 29 &&
      kpi.id !== 10 &&
      kpi.id !== 26 &&
      kpi.id !== kpis.LINEAR_CATEGORY &&
      kpi.id !== kpis.LINEAR_BRAND &&
      kpi.id !== kpis.PDL_BRAND &&
      kpi.id !== kpis.PDL &&
      kpi.id !== kpis.MEA &&
      kpi.id !== kpis.PLV&&
      kpi.id !== kpis.NB_BRI &&
      kpi.id !== kpis.NB_VENDEURS &&
      kpi.id !== kpis.PDL_FAMILY
    );
  }

  isTableAvailable(kpi) {return false
    kpi.client_id = kpi.client_id || [];
    return (
      //kpi.id !== 17 &&
      kpi.id !== 10 &&
      kpi.id !== 26 &&
      kpi.id !== kpis.PDL_BRAND &&
      kpi.id !== kpis.LINEAR_CATEGORY &&
      kpi.id !== kpis.LINEAR_BRAND &&
      kpi.id !== kpis.PDL &&
      kpi.id !== kpis.MEA &&
      kpi.id !== kpis.PLV &&
      kpi.id !== kpis.NB_BRI &&
      kpi.id !== kpis.NB_VENDEURS &&
      kpi.id !== kpis.PDL_FAMILY &&
      (kpi.calculation_type === "sum" ||
        kpi.calculation_type === "somme" ||
        kpi.calculation_type === "Rapport" ||
        kpi.format === "text" ||
        [1, 3, 9, 16, 14, 10, 18, 29, 34, 229, 437, 461].indexOf(kpi.id) !== -1)
    );
  }

  isSummaryAvailable(kpi) {return true;
    kpi.client_id = kpi.client_id || [];
    return [kpis.DN, kpis.VISITES, kpis.PDL_BRAND, kpis.PDL, kpis.MEA, kpis.PLV, kpis.NB_BRI, kpis.NB_VENDEURS, kpis.PDL_FAMILY].indexOf(kpi.id) !== -1;
  }
  render() {
    const { item, graphLoading, view, changeLeftMenuSubItem, changeLeftMenuKpi, ...others } = this.props;
    const kpiIconClassName = StatsUtils.kpiToIconClassName(item.kpi);
    return (
      <SubMenu
        key={item.key}
        title={
          <span>
            {/*<span className={"p-sidebar-menu-item-label-ico icon-"+kpiIconClassName}/>*/}
            <span>{item.label}</span>
          </span>
        }
        {...others}
        onTitleClick={this.onKpiSelected.bind(this)}
      >
        {this.isDashboardAvailable(item.kpi) && (
          <Menu.Item
            disabled={graphLoading}
            key={item.key + "-dashboard"}
            onClick={e => {
              this.onKpiViewSelected(e, "dashboard");
            }}
          >
            Dashboard
          </Menu.Item>
        )}

        {this.isPerfAvailable(item.kpi) && (
          <Menu.Item
            disabled={graphLoading}
            key={item.key + "-perf"}
            onClick={e => {
              this.onKpiViewSelected(e, "performance");
            }}
          >
            Performance
          </Menu.Item>
        )}

        {this.isTableAvailable(item.kpi) && (
          <Menu.Item
            disabled={graphLoading}
            key={item.key + "-data"}
            onClick={e => {
              this.onKpiViewSelected(e, "table");
            }}
          >
            Données
          </Menu.Item>
        )}

        {this.isSummaryAvailable(item.kpi) && (
          <Menu.Item
            disabled={graphLoading}
            key={item.key + "-summary"}
            onClick={e => {
              this.onKpiViewSelected(e, "summary");
            }}
          >
            Synthèse
          </Menu.Item>
        )}
      </SubMenu>
    );
  }
}

//LeftMenuItem.propTypes = {};

const mapStateToProps = state => {
  const stats = state.stats || {};
  return {
    view: stats.view,
    graphLoading: stats.graphLoading || false
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    changeLeftMenuSubItem: view => {
      dispatch(changeLeftMenuSubItem(view));
    },
    changeLeftMenuKpi: (kpiId, init, viewType) => {
      dispatch(changeLeftMenuKpi(kpiId, init, viewType));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LeftMenuItem);



// WEBPACK FOOTER //
// src/modules/stats/components/LeftMenu/LeftMenuItem.js